export default "__VITE_ASSET__5L2qGcWf__"